module.exports = __webpack_public_path__ + "img/toplogo2.1107189b.png";